import { PERMISSIONS } from "shared/enums/permissions.enum";
import { Company, CurrentSubscription } from "../companies/company";
import { Warehouse } from "../inventory/warehouse";
import { Role } from "./role";
import { Media } from "../common/media";

export class User {
    id!: string;
    name: string = '';
    email: string = ''
    roleId: string = ''
    userType: string = ''
    companyId: string = '';
    company!: Company
    permissions: PERMISSIONS[] = []
    currentSubscription: any;
    emailVerified!: boolean;
    stripeCustomerId!: string;
    lastLogin!: string | null;
    isActive!: boolean;
    warehouses: Warehouse[] = []
    role!: Role;
    createdAt!: string;
    updatedAt!: string;
    profilePic: Media | null = null;
    profilePicId: string | null = null;

    constructor(data: Partial<User> = {}) {
        Object.assign(this, data);
        if (data.role) this.role = new Role(data.role);
        if (data.company) this.company = new Company(data.company);
        if (data.currentSubscription) new CurrentSubscription(data.currentSubscription)
        if (data.profilePic) this.profilePic = new Media(data.profilePic)
    }
}